"use client";
import { anatomy } from "@zag-js/color-picker";
//#region src/components/color-picker/color-picker.anatomy.ts
var colorPickerAnatomy = anatomy.extendWith("view");
//#endregion
export { colorPickerAnatomy };
